import { createGlobalStyle } from 'styled-components';

export const InjectOpSpe = createGlobalStyle`
  :root[data-theme='dark'] {
    --op-spe-boulanger: url(/assets-react/op-spe/boulanger.svg);
    --op-spe-proton: url(/assets-react/op-spe/proton.svg);
    --op-spe-proton-purple: url(/assets-react/op-spe/proton-purple.svg);
  }

  :root[data-theme='light'] {
    --op-spe-boulanger: url(/assets-react/op-spe/boulanger.svg);
    --op-spe-proton: url(/assets-react/op-spe/proton.svg);
    --op-spe-proton-purple: url(/assets-react/op-spe/proton-purple.svg);
  }
`;
